
/** Common application environment types */
export enum ApplicationEnvironmentEnum {
  /** Development environment */
  DEVELOPMENT = 'development',
  /** Staging (test) environment */
  STAGING = 'staging',
  /** Production environment */
  PRODUCTION = 'production',
  /** "Atrium" special environment */
  ATRIUM = 'atrium',
  /** "Leber" special environment */
  LEBER = 'leber',
}
